export {
  getAdmissionICD10CodesFromExtension,
  getExtensionCodingValue,
  isRequiredCoding,
  mapICD10CodeToExtension,
} from './extension';
export * from './mapping';
export type {
  Admission,
  AdmissionCreateMedicalAidAuthorization,
  AdmissionCreateRequest,
  AdmissionCreateResponse,
  AdmissionDiagnoses,
  AdmissionDiagnosis,
  AdmissionDischargeRequest,
  AdmissionGetAllParams,
  AdmissionGetAllResponse,
  AdmissionGetAllResponseWithMedia,
  AdmissionGetOneByIdResponse,
  AdmissionGetParams,
  AdmissionGetResponse,
  AdmissionGetResponseWithMedia,
  AdmissionGetResponseWithVitals,
  AdmissionInvalidateRequest,
  AdmissionLocation,
  AdmissionLocationUpdateRequest,
  AdmissionMedia,
  AdmissionMedicalAidAuthorization,
  AdmissionPauseRequest,
  AdmissionSearch,
  AdmissionStartRequest,
  AdmissionStatus,
  AdmissionUpdateFields,
  AdmissionUpdateInput,
  AdmissionUpdateRequest,
  AdmissionUpdateResponse,
  AdmissionWithPartialPrimaryCode,
  AdmissionWithUsages,
  BaseAdmission,
  BaseAdmissionSchema,
  CreateAdmissionDiagnosis,
  CreateAdmissionInput,
  CreateAdmissionSchemaWithPatientInput,
  EncounterStatus,
  MedicalAidAdmission,
} from './schema';
export {
  AdmissionDiagnosisSchema,
  AdmissionDischargeRequestSchema,
  AdmissionGetAllResponseSchema,
  AdmissionGetOneByIdResponseSchema,
  AdmissionGetResponseSchema,
  AdmissionGetResponseWithMediaSchema,
  AdmissionInvalidateRequestSchema,
  AdmissionLocationSchema,
  AdmissionLocationUpdateSchema,
  AdmissionMediaSchema,
  AdmissionMedicalAidAuthorizationSchema,
  AdmissionPauseRequestSchema,
  AdmissionSchema,
  AdmissionSearchSchema,
  AdmissionStartRequestSchema,
  AdmissionStatusHistorySchema,
  AdmissionSubjectSchema,
  AdmissionUpdateSchema,
  AdmissionVitalSummarySchema,
  AdmissionWithPartialPrimaryCodeSchema,
  AdmissionWithUsagesSchema,
  BaseAdmissionMedicalAidAuthorizationSchema,
  CoverageIdentifiersSchema,
  CreateAdmissionDiagnosisSchema,
  CreateAdmissionSchema,
  CreateAdmissionSchemaWithPatientSchema,
  EncounterDischargeStatusReason,
  EncounterInvalidateStatusReason,
  EncounterPausedStatusReason,
  EncounterStatusReasonSchema,
  ICD10CodeSchema,
  MedicalAidAdmissionSchema,
} from './schema';
export {
  admissionCreateRequestSchema,
  admissionLocationUpdateRequestSchema,
  admissionRequestSchemaFields,
  admissionUpdateRequestSchema,
  allergySchema,
  medicalAidAuthorizationCreateSchemaFields,
} from './validation';
